import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "../components/modules/OrdersTable/ui.helpers";

const OrdersUIContext = createContext();

export function useOrdersUIContext() {
  return useContext(OrdersUIContext);
}

export const OrdersUIConsumer = OrdersUIContext.Consumer;

export function OrdersUIProvider({ UIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);

  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }
      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }
      return nextQueryParams;
    });
  }, []);

  const { openOrderDetailDialog } = UIEvents;

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    openOrderDetailDialog,
  };

  return (
    <OrdersUIContext.Provider value={value}>
      {children}
    </OrdersUIContext.Provider>
  );
}
